import { render, staticRenderFns } from "./KeysTab.vue?vue&type=template&id=3f6acb68"
import script from "./KeysTab.vue?vue&type=script&lang=js"
export * from "./KeysTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports